export default __webpack_public_path__ + "static/media/BLR22.46b4fbd0.jpg";